import { CardGroup as CardGroupDto, type CardGroupResponse } from '@mynt/backoffice-api-spec/cards'
import { CardGroup, type CardGroupData } from './api'

export const mapCardGroupDtoToCardGroup = (dto: CardGroupDto): CardGroup => {
  switch (dto) {
    case CardGroupDto.A:
      return CardGroup.A
    case CardGroupDto.B:
      return CardGroup.B
    case CardGroupDto.C:
      return CardGroup.C
    case CardGroupDto.D:
      return CardGroup.D
    case CardGroupDto.E:
      return CardGroup.E
    case CardGroupDto.F:
      return CardGroup.F
    case CardGroupDto.NOT_SET:
      return CardGroup.NOT_SET
    case CardGroupDto.UNKNOWN:
      return CardGroup.UNKNOWN
  }
}

export const mapCardGroupToCardGroupDto = (group: CardGroup): CardGroupDto => {
  switch (group) {
    case CardGroup.A:
      return CardGroupDto.A
    case CardGroup.B:
      return CardGroupDto.B
    case CardGroup.C:
      return CardGroupDto.C
    case CardGroup.D:
      return CardGroupDto.D
    case CardGroup.E:
      return CardGroupDto.E
    case CardGroup.F:
      return CardGroupDto.F
    case CardGroup.NOT_SET:
      return CardGroupDto.NOT_SET
    case CardGroup.UNKNOWN:
      return CardGroupDto.UNKNOWN
  }
}

export const mapCardGroupResponseToCardGroupData = (response: CardGroupResponse): CardGroupData => ({
  group: mapCardGroupDtoToCardGroup(response.cardGroup),
  isOverridden: response.isOverridden,
})
